import { mapGetters, mapState } from 'vuex';

import { ActionOnPageFocusMixin } from '@/core/mixins';
import { UserService, UserConstants } from '@/core/user';
import { AuthRoutes } from '@/auth/mixins';

// @vue/component
export default {
  mixins: [
    ActionOnPageFocusMixin,
    AuthRoutes,
  ],
  computed: {
    ...mapGetters(['hasAuthToken']),
    ...mapState(['user']),
  },
  mounted() {
    this.sendVerificationEmailRequest();
  },
  methods: {
    async sendVerificationEmailRequest() {
      await UserService.requestEmailVerification(this.$store.state.user.uuid, this.$route.query);
    },
    async checkEmailConfirmedState() {
      try {
        await UserService.getUser();

        if (this.user.confirmed || this.user.user_type.name !== UserConstants.user_type.vendor.key) {
          this.$router.push(this.routes.redirect);
        }
      } catch (error) {
        if (!this.hasAuthToken) {
          this.$router.push(this.routes.login);
        }
      }
    },
    performActionIfFocused() {
      UserService.clearCache();
      this.checkEmailConfirmedState();
    },
  },
};
